import { makeStyles } from "tss-react/mui";
import { MiIcon } from "@miplatform/components";
import { mdiArrowRight } from "@mdi/js";
import { Box, Typography } from "@mui/material";

export function LegalCard({
  title,
  subtitle,
  link,
}: {
  title: string;
  subtitle: string;
  link: { href: string; title: string };
}) {
  const { classes, theme } = useStyles();
  return (
    <Box className={classes.legalCard}>
      <Typography variant="HD3" color={theme.palette.text.primary}>
        {title}
      </Typography>
      <Typography variant="BD3" color={theme.palette.text.secondary}>
        {subtitle}
      </Typography>
      <a
        className={classes.externalLink}
        href={link.href}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Typography
          className={classes.linkText}
          variant="BD3"
          color={theme.palette.primary.main}
        >
          {link.title}
          <MiIcon path={mdiArrowRight} size={0.75} />
        </Typography>
      </a>
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  legalCard: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(4),
  },
  externalLink: {
    textDecoration: "none",
    marginTop: theme.spacing(1),
  },
  linkText: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    color: theme.palette.secondary.main,
  },
}));
